import { useWorkareaGroupsQuery } from '../../../domain/workareas/groupsQueries';

type Props = {
  jobId: number
  workAreaIds: string
}

const RouteModalJobWorkAreas = ({ jobId, workAreaIds }: Props) => {
  const { data: workareaGroups } = useWorkareaGroupsQuery(jobId);

  const workAreaIdArray = workAreaIds ? workAreaIds.split(',').map(id => parseInt(id.trim())).filter(id => !isNaN(id)) : [];

  const workAreaNames = workAreaIdArray.map(id => {
    for (const group of workareaGroups || []) {
      const workarea = group.workareas.find(wa => wa.id === id);
      if (workarea) {
        return workarea.name;
      }
    }
    return null;
  }).filter(Boolean);

  if (workAreaNames.length === 0) {
    return <div style={{ fontSize: '12px', color: '#999', paddingLeft: '12px' }}>No work areas</div>;
  }

  return (
    <div style={{ fontSize: '12px', color: '#666', paddingLeft: '12px' }}>
      {workAreaNames.map((name, index) => (
        <div key={index} style={{ marginBottom: '4px' }}>{name}</div>
      ))}
    </div>
  );
};

export default RouteModalJobWorkAreas;
